import { apiGet } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/stock/product/trait', query).then(result => result.response);
  },
};
